import * as React from "react";

export const SvgInfo = (props) => (
	<svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M8 6.056a.645.645 0 1 0 0-1.29.645.645 0 0 0 0 1.29ZM9.144 10.31h-.686V7.74A.459.459 0 0 0 8 7.282H6.855a.459.459 0 0 0 0 .917h.686v2.57c0 .253.205.459.458.459h1.145a.459.459 0 1 0 0-.918Z"
			fill="#595959"
			stroke="#595959"
			strokeWidth={0.1}
		/>
		<path
			d="M8 1.6C4.47 1.6 1.6 4.471 1.6 8c0 3.529 2.87 6.4 6.4 6.4 3.529 0 6.4-2.87 6.4-6.4 0-3.529-2.871-6.4-6.4-6.4Zm0 11.883A5.489 5.489 0 0 1 2.517 8 5.489 5.489 0 0 1 8 2.517 5.489 5.489 0 0 1 13.482 8 5.489 5.489 0 0 1 8 13.483Z"
			fill="#595959"
			stroke="#595959"
			strokeWidth={0.1}
		/>
	</svg>
);
